module.exports = __webpack_public_path__ + "static/media/auv.ba9aeeac.png";